module.exports = __webpack_public_path__ + "static/media/slide-five.6e1db584.webp";